import { FC } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import SvgMask from '../_Helpers/SvgMask';

interface HubSpotContactModalProps {
	isOpen: boolean;
	onClose: () => void;
	onShow?: () => void;
	isSubmitted?: boolean;
	title?: string;
	description?: string;
	targetId?: string;
}

const HubSpotContactModal: FC<HubSpotContactModalProps> = ({
	isOpen,
	onClose,
	onShow,
	isSubmitted = false,
	title = 'Contact Little Learners',
	description = 'Add your message below and we will aim to get back to you within 2 business days.',
	targetId = 'hubspot-target'
}) => {
	return (
		<Modal show={isOpen} onHide={onClose} onShow={onShow} centered>
			<Modal.Body>
				<button type="button" className="btn-reset close" aria-label="Close" onClick={onClose}>
					<SvgMask path="/svg/cross.svg" width={16} height={16} />
				</button>
				<h2 className="m-0">
					<strong>{title}</strong>
				</h2>
				{!isSubmitted && <p className="m-0">{description}</p>}
				<div id={targetId}>
					<div className="text-center py-5">
						<Spinner animation="border" />
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default HubSpotContactModal;
